<template>
	<div class="user-registration-layout flex-centerize">
		<div class="content-container display-flex flex-column flex-justify-space-between">
			<div class="display-flex flex-column flex-centerize width-100">
				<div class="title-text">This feature is powered by Ply</div>
				<div class="title-description-text mb-6">Ply lets you add features to your apps</div>
				<InstallablePreview class="width-100" :installableId="installableId" />
			</div>

			<div class="display-flex flex-column flex-centerize">
				<div class="card-container pt-6 pb-4 display-flex flex-column flex-centerize">
					<v-form v-model="isFormValid" ref="loginForm" @submit.prevent="login" class="user-input-box">
						<AnemicButton class="google-login-button mt-9 mb-5" @click="signInWithGoogle">
							<SIcon name="google-logo" class="mr-2" />
							Continue with Google
						</AnemicButton>

						<div class="display-flex width-100 flex-row flex-align-center px-5 mb-5">
							<div class="divider width-100"></div>
							<div class="divider-text mx-2">or</div>
							<div class="divider width-100"></div>
						</div>

						<SignupTextField
							label="Enter work email"
							iconName="email"
							:rules="emailRules"
							v-model="userEmail"
							type="email"
							data-cy="registration-username"
							autofocus
							single-line
							placeholder="mail@email.com"
						>
						</SignupTextField>
						<SignupTextField
							type="password"
							label="Password"
							iconName="input-key"
							:rules="requiredRules"
							v-model="userPassword"
							data-cy="registration-password"
							placeholder="Password (at least 8 characters)"
						/>
						<AnemicButton :loading="submittingForm" class="login-button width-100" type="submit" data-cy="registration-continue">
							Sign in
						</AnemicButton>
						<div v-if="errorMessage" class="error-message mt-4">{{ errorMessage }}</div>

						<div class="forgot-password-link">
							<span @click="navigateTo({ name: 'Forgot', params: { origEmail: userEmail } })" class="link-text">
								Forgot your password
							</span>
						</div>
					</v-form>
				</div>
				<div class="bottom-section mt-2">
					Don't have an account?
					<a @click="navigateTo({ name: 'Signup' })" class="link-text underline">Get started</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UserRegistrationMixin from './userRegistration/helpers/UserRegistrationMixin';
import InstallablePreview from '@/components/Project/InstallablePreview.vue';
import SignupTextField from './userRegistration/components/SignupTextField';
import UserRegistrationService from './userRegistration/helpers/UserRegistrationService';
import { mapActions } from 'vuex';

export default {
	name: 'InstallationLogin',
	mixins: [UserRegistrationMixin],
	components: { InstallablePreview, SignupTextField },
	props: {
		token: { type: String },
	},
	computed: {
		installableId() {
			return this.$route.params.installableId;
		},
	},
	methods: {
		...mapActions(['loginWithUserPass', 'loginWithGoogleToken']),
		async login() {
			this.errorMessage = '';
			this.$refs.loginForm.validate();
			if (this.isFormValid && this.userEmail) {
				this.submittingForm = true;
				this.errorMessage = await this.loginWithUserPass({
					username: this.userEmail,
					password: this.userPassword,
				}).finally(() => {
					this.submittingForm = false;
				});
				console.log(this.errorMessage);
			}
		},
		async signInWithGoogle() {
			const idToken = await UserRegistrationService.signInWithGoogle();
			const loginRes = await this.loginWithGoogleToken({ token: idToken, isInstallable: true }).catch((err) => {
				this.$toast.error(err, { timeout: 3000 });
			});
			if (loginRes.success === false) {
				this.errorMessage = 'Login failed. Please sign up.';
			}
		},
	},
	mounted() {
		UserRegistrationService.initializeGoogleAuth();
	},
	data() {
		return {
			auth2: null,
			stage: 1,
			fakeUser: {
				acceptPrivacy: false,
			},
			userEmail: '',
			userPassword: '',
			errorMessage: '',
			submittingForm: false,
			loginTokenLoading: false,
			requiredRules: UserRegistrationService.getRequiredRules(),
			emailRules: UserRegistrationService.getEmailValidationRules(),
			isFormValid: false,
		};
	},
};
</script>

<style scoped lang="scss">
.forgot-password-link {
	text-align: center;
	margin: 10px 0 20px 0;
	.link-text {
		cursor: pointer;
		font-size: 12px;
		color: var(--primary-color);
	}
}
.user-registration-layout {
	width: 100vw;
	height: 100vh;
	background: var(--page-background);
	background-image: url('../assets/icons/registration-background.png');

	.content-container {
		width: 820px;
		min-height: 820px;
		padding: 100px 120px 42px 120px;
	}

	.title-text {
		font-size: 20px;
		font-weight: bold;
		color: var(--primary-font-color);
	}
	.title-description-text {
		font-size: 16px;
		color: var(--primary-font-color);
	}

	.header-container {
		height: 60px;
		padding: 8px 52px;
		background: var(--bg-color);
		border-bottom: 1px solid var(--border-color);

		.login-button {
			padding: 0px;
			height: 45px;
			width: 132px;
			background: transparent;
			border: 1px solid var(--border-color);

			font-size: 14px !important;
			color: #384252 !important;
		}
	}

	.conetnet-container {
		.slot-card {
			text-align: center;
			border-radius: 10px;
			background: var(--bg-color);
			padding: 38px 65px 28px 65px;
			box-shadow: 0px 3px 6px var(--shadow-color);
		}
	}

	.footer-container {
		height: 60px;
	}
}

.bottom-section {
	font-size: 14px;
	.link-text {
		cursor: pointer;
		text-decoration: underline;
		color: var(--primary-color);
	}
}
.card-container {
	width: 580px;
	height: 400px;
	border-radius: 10px;
	background: var(--bg-color);
	padding: 24px 140px 16px 140px;
	box-shadow: 0px 3px 6px var(--shadow-color);
}

.card-title {
	font-size: 16px;
	font-weight: 600;
	color: var(--primary-font-color);
}
.google-login-button {
	padding: 0px;
	width: 300px;
	height: 45px;
	background: var(--bold-border-color) !important;
	color: var(--bg-color);
	font-size: 14px !important;
}

.divider-text {
	font-size: 14px;
	color: #babdc4;
}
.divider {
	height: 1px;
	margin-top: 2px;
	background: #babdc4;
}

.login-button {
	height: 45px;
	padding: 0px;
	font-size: 14px !important;
	color: var(--bold-border-color);
	background: var(--bg-color) !important;
	border: 1px solid var(--bold-border-color);
}
.continue-with-email {
	cursor: pointer;
	font-size: 14px;
	color: var(--primary-color);
	text-decoration: underline;
}
.error-message {
	max-width: 300px;
	color: red;
}
</style>
